import React from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "./Header";
import Footer from "./Footer";

/*
 * Layout for redesigned public pages: sticky header, content, footer.
 * When the mini-player is showing, bottom padding keeps page content clear of
 * the fixed bar (it hides while the page's own player card is on screen). Legacy pages keep rendering their own header/footer until
 * each is migrated (Phase 2 onward).
 */

export default function PublicLayout({ children }) {
  const hasPlayer = useSelector((s) => Boolean(s.player.current) && !s.player.cardOnScreen);
  return (
    <div className={`min-h-screen flex flex-col bg-ic-offwhite ${hasPlayer ? "pb-[104px]" : ""}`}>
      <Header />
      <main className="flex-1 flex flex-col">{children || <Outlet />}</main>
      <Footer />
    </div>
  );
}
